import * as actions from "../actionTypes"

const initialState = {
    value: {},
}

export default function mlModels(state = initialState, action) {
    switch (action.type) {
        case actions.SET_ML_MODELS: {
            return {
                ...state,
                value: action.payload.value,
            }
        }

        default:
            return state
    }
}
